/*
 * Automatically generated by codegen/smith.ts.
 * Do not edit this file or add other files to this directory.
 */
import { seamApiLtsVersion } from '../../../../lib/lts-version.js';
import { createClient } from '../../../../lib/seam/connect/client.js';
import { isSeamHttpWithoutWorkspaceOptionsWithClient, isSeamHttpWithoutWorkspaceOptionsWithConsoleSessionToken, isSeamHttpWithoutWorkspaceOptionsWithPersonalAccessToken, SeamHttpWithoutWorkspaceInvalidOptionsError, } from '../../../../lib/seam/connect/options.js';
import { limitToSeamHttpRequestOptions, parseOptions, } from '../../../../lib/seam/connect/parse-options.js';
import { SeamHttpSeamCustomerV1Connectors, } from './seam/customer/v1/connectors/index.js';
import { SeamHttpWorkspaces, } from './workspaces/index.js';
export class SeamHttpEndpointsWithoutWorkspace {
    client;
    defaults;
    ltsVersion = seamApiLtsVersion;
    static ltsVersion = seamApiLtsVersion;
    constructor(options = {}) {
        const opts = parseOptions(options);
        this.client = 'client' in opts ? opts.client : createClient(opts);
        this.defaults = limitToSeamHttpRequestOptions(opts);
    }
    static fromClient(client, options = {}) {
        const constructorOptions = { ...options, client };
        if (!isSeamHttpWithoutWorkspaceOptionsWithClient(constructorOptions)) {
            throw new SeamHttpWithoutWorkspaceInvalidOptionsError('Missing client');
        }
        return new SeamHttpEndpointsWithoutWorkspace(constructorOptions);
    }
    static fromConsoleSessionToken(consoleSessionToken, options = {}) {
        const constructorOptions = { ...options, consoleSessionToken };
        if (!isSeamHttpWithoutWorkspaceOptionsWithConsoleSessionToken(constructorOptions)) {
            throw new SeamHttpWithoutWorkspaceInvalidOptionsError('Missing consoleSessionToken');
        }
        return new SeamHttpEndpointsWithoutWorkspace(constructorOptions);
    }
    static fromPersonalAccessToken(personalAccessToken, options = {}) {
        const constructorOptions = { ...options, personalAccessToken };
        if (!isSeamHttpWithoutWorkspaceOptionsWithPersonalAccessToken(constructorOptions)) {
            throw new SeamHttpWithoutWorkspaceInvalidOptionsError('Missing personalAccessToken');
        }
        return new SeamHttpEndpointsWithoutWorkspace(constructorOptions);
    }
    get '/seam/customer/v1/connectors/authorize'() {
        const { client, defaults } = this;
        if (!this.defaults.isUndocumentedApiEnabled) {
            throw new Error('Cannot use undocumented API without isUndocumentedApiEnabled');
        }
        return function seamCustomerV1ConnectorsAuthorize(...args) {
            const seam = SeamHttpSeamCustomerV1Connectors.fromClient(client, defaults);
            return seam.authorize(...args);
        };
    }
    get '/workspaces/create'() {
        const { client, defaults } = this;
        return function workspacesCreate(...args) {
            const seam = SeamHttpWorkspaces.fromClient(client, defaults);
            return seam.create(...args);
        };
    }
    get '/workspaces/list'() {
        const { client, defaults } = this;
        return function workspacesList(...args) {
            const seam = SeamHttpWorkspaces.fromClient(client, defaults);
            return seam.list(...args);
        };
    }
}
//# sourceMappingURL=seam-http-endpoints-without-workspace.js.map